import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  withArrow?: boolean;
  href?: string;
}
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53169708728657:1';
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withArrow = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded-none tracking-wide focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#C9A66B] cursor-pointer';
  const variants = {
    primary: 'bg-[#111111] text-[#F6F1E8] hover:bg-[#2a2a2a] shadow-md hover:shadow-lg',
    secondary: 'bg-transparent border border-[#111111] text-[#111111] hover:bg-[#111111] hover:text-[#F6F1E8]'
  };
  const sizes = {
    sm: 'text-xs px-4 py-2',
    md: 'text-sm px-6 py-3',
    lg: 'text-base px-8 py-4'
  };
  const allClasses = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  const content = <>
      {children}
      {withArrow && <ArrowRight className="ml-2 h-4 w-4" data-id="element-290" />}
    </>;
  const linkHref = href || CHECKOUT_URL;
  const isAnchor = linkHref.startsWith('#');
  if (isAnchor) {
    return <a href={linkHref} className={allClasses} onClick={e => {
      e.preventDefault();
      const target = document.querySelector(linkHref);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }} data-id="element-291">
        {content}
      </a>;
  }
  return <a href={linkHref} target="_blank" rel="noopener noreferrer" className={allClasses} onClick={e => {
    if (typeof window !== 'undefined' && window.fbq) {
      e.preventDefault();
      window.fbq('track', 'AddToCart', {
        content_name: 'Método Faceless Spain',
        content_type: 'product',
        value: 19.0,
        currency: 'EUR'
      });
      setTimeout(() => {
        window.open(linkHref, '_blank', 'noopener,noreferrer');
      }, 300);
    }
  }} data-id="element-292">
      {content}
    </a>;
}